import { EntityCommand, EntityCommandPropertyValues, EntityCommandTypeEnum, IEntityCommand } from "@seriously-rad/seriouslyrad-framework-core/EntityCommand";
import { EntityCommandInformation } from "@seriously-rad/seriouslyrad-framework-core/EntityCommandInformation";
import { PartialNullable } from "@seriously-rad/seriouslyrad-framework-core/Extensions";
import { StringHelper } from "@seriously-rad/seriouslyrad-framework-core/Helpers/StringHelper";
import { Property } from "@seriously-rad/seriouslyrad-framework-core/RadObject";
import { PermissionEvaluator } from "@seriously-rad/seriouslyrad-framework-core/Server/DotNet/SeriouslyRAD.Framework.Data.Entities/Evaluation/Evaluators/PermissionEvaluator";
import { WebApiClientService } from "@seriously-rad/seriouslyrad-framework-core/Server/WebApiClientService";
import { ServiceManager } from "@seriously-rad/seriouslyrad-framework-core/ServiceManager";
import { PageManager } from "@seriously-rad/seriouslyrad-framework-core/Ui/PageManager";
import { NAMESPACE } from "./_Namespace";

export type EntityCommandIntegratedDataSetRecordLogEntryOpenPropertyValues =
    EntityCommandPropertyValues
    & {
    };

export type EntityCommandIntegratedDataSetRecordLogEntryOpenProperties = {
    [name in keyof EntityCommandIntegratedDataSetRecordLogEntryOpenPropertyValues]: Property<EntityCommandIntegratedDataSetRecordLogEntryOpenPropertyValues[name]>
};

export interface IEntityCommandIntegratedDataSetRecordLogEntryOpen extends IEntityCommand, EntityCommandIntegratedDataSetRecordLogEntryOpenProperties
{
}

export class EntityCommandIntegratedDataSetRecordLogEntryOpen extends EntityCommand implements IEntityCommandIntegratedDataSetRecordLogEntryOpen
{
    // #region Static

    public static override classNamespace = NAMESPACE + "EntityCommandIntegratedDataSetRecordLogEntryOpen";
    public static override className = "EntityCommandIntegratedDataSetRecordLogEntryOpen";

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<EntityCommandIntegratedDataSetRecordLogEntryOpenPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                description: "Open",
                entityName: "IntegratedDataSetRecordLogEntry",
                isDefault: true,
                key: "OPEN",
                permission: PermissionEvaluator.permissionLevels.read,
                type: EntityCommandTypeEnum.entity,
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Constructor

    constructor(propertyValues?: PartialNullable<EntityCommandIntegratedDataSetRecordLogEntryOpenPropertyValues>)
    {
        super(propertyValues);
    }

    // #endregion

    // #region Overrides

    protected override _executeAsync(entityCommandInformation: EntityCommandInformation, value?: any)
    {
        return (
            super._executeAsync(entityCommandInformation, value)
                .then(() =>
                {
                    const
                        recordId = entityCommandInformation.getRecordId();

                    if (!recordId)
                        return;

                    return (
                        ServiceManager.getRequired(WebApiClientService)
                            .createEntityGetRequest("IntegratedDataSetRecordLogEntries", recordId, ["id", "integratedDataSetRecord.id"])
                            .executeAsync()
                            .then(data =>
                            {
                                PageManager.instance?.navigateAsync(StringHelper.format("/integrateddatasetrecords/{0}", data.integratedDataSetRecord.id));
                            })
                    );
                })
        );
    }

    // #endregion

    // #endregion
}

